$(document).on('change paste', '[data-validator-number]', function (event) {
    var decimal_place = $(this).data('validator-number');
    var val = $(this).val().replace(/[^0-9\.\,]/g, '').replace(/[,]/g, '.')

    if (decimal_place > 0) {
        val = parseFloat(val).toFixed(decimal_place);
    } else {
        val = parseInt(val);
    }

    $(this).val(val);

    if ((event.which !== 46 ||
        $(this).val().indexOf('.') !== -1) && (event.which < 48 ||
        event.which > 57) && ((event.which !== 110 && event.which !== 44) ||
        $(this).val().indexOf('.') !== -1)) {
        event.preventDefault();
    }
});